import { Navigate, useRoutes } from 'react-router-dom';

import { DashboardLayout } from '../layouts/dashboard';
import { SimpleLayout } from '../layouts/simple';
import ForgotPassword from '../pages/Auth/ForgotPassword';
import ForgotPasswordEmailSent from '../pages/Auth/ForgotPasswordEmailSent';
import SignIn from '../pages/Auth/SignIn';
import SignUp from '../pages/Auth/SignUp';
import SignUpCompletePage from '../pages/Auth/SignUpCompletePage';
import SignUpPasswordChang from '../pages/Auth/SignUpPasswordChang';
import SignUpVerification from '../pages/Auth/SignUpVerification';
import Bins from '../pages/Home/Bins';
import Deliveries from '../pages/Home/Deliveries';
import PickList from '../pages/Home/PickList';
import Racks from '../pages/Home/Racks';
import Page404 from '../pages/Page404';
import Settings from '../pages/Settings/Settings';
import User from '../pages/User/User';
import {
  ACCOUNT,
  BINS,
  DELIVERIES,
  HOME,
  NOTFOUND,
  PICKLIST,
  RESET_PASSWORD,
  RESET_PASSWORD_VERIFY,
  SETTINGS,
  SIGNIN,
  SIGNUP,
  SIGNUPCHANGEPASSWORD,
  SIGNUPCOMPLETE,
  USER,
  VERIFY_OTP,
} from './routeConstants';

export default function Router() {
  return useRoutes([
    {
      path: HOME,
      element: <DashboardLayout />,
      children: [
        {
          path: HOME,
          element: <Racks />,
        },
        {
          path: BINS,
          element: <Bins />,
        },
        {
          path: PICKLIST,
          element: <PickList />,
        },
        {
          path: DELIVERIES,
          element: <Deliveries />,
        },
        {
          path: SETTINGS,
          element: <Settings />,
        },
        {
          path: USER,
          element: <User />,
        },
      ],
    },

    {
      path: ACCOUNT,
      element: <SimpleLayout />,
      children: [
        { path: SIGNIN, element: <SignIn /> },
        { path: `${SIGNUP}/:base64Secret`, element: <SignUp /> },
        { path: SIGNUPCHANGEPASSWORD, element: <SignUpPasswordChang /> },
        { path: SIGNUPCOMPLETE, element: <SignUpCompletePage /> },
        { path: VERIFY_OTP, element: <SignUpVerification /> },
        { path: RESET_PASSWORD, element: <ForgotPassword /> },
        {
          path: RESET_PASSWORD_VERIFY,
          element: <ForgotPasswordEmailSent />,
        },
        { path: NOTFOUND, element: <Page404 /> },
        { path: '*', element: <Navigate to={`/${NOTFOUND}`} replace /> },
      ],
    },
    { path: '*', element: <Page404 /> },
  ]);
}
